import { ArrowLeftIcon, ChevronLeftIcon, ChevronRightIcon, TrashIcon } from "../../../automationStudioIcons";
import ButtonComponent from "../../../../customButton";
import styles from "../../../../../styles/automationStudio/automationStudio.module.scss";
import { LABELS } from "../../../content";

export default function StepEditorHeader({
    showResultsBackButton,
    onBackToResults,
    onBackToInstructions,
    onPrevStep,
    onNextStep,
    isEditorLocked,
    hasPrevious,
    hasNext,
    onDelete,
    isExecuting,
}) {
    return (
        <div className={`${styles.stepEditorHeader} ${styles.stepEditorHeaderCompact}`}>
            <div className={styles.stepEditorHeaderRow}>
                <div className={styles.stepEditorHeaderCluster}>
                    {showResultsBackButton ? (
                        <>
                            <ButtonComponent
                                ctaText={LABELS.RESULTS}
                                variant="primary"
                                size="small"
                                className="white bg-primary"
                                startIcon={<ArrowLeftIcon className="icon white" />}
                                onClick={onBackToResults}
                            />
                            <ButtonComponent
                                ctaText={LABELS.INSTRUCTIONS}
                                variant="primary"
                                size="small"
                                className="white bg-primary"
                                startIcon={<ArrowLeftIcon className="icon white" />}
                                onClick={onBackToInstructions}
                            />
                        </>
                    ) : (
                        <ButtonComponent
                            ctaText={LABELS.INSTRUCTIONS}
                            variant="primary"
                            size="small"
                            className="white bg-primary"
                            startIcon={<ArrowLeftIcon className="icon white" />}
                            onClick={onBackToInstructions}
                        />
                    )}
                </div>

                <div className={styles.stepEditorHeaderClusterTight}>
                    <button
                        type="button"
                        onClick={onPrevStep}
                        disabled={isEditorLocked || !hasPrevious}
                        className={`${styles.navButton} ${styles.asIconButton}`}
                        aria-label="Previous step"
                    >
                        <ChevronLeftIcon style={{ width: '16px', height: '16px' }} />
                    </button>
                    <button
                        type="button"
                        onClick={onNextStep}
                        disabled={isEditorLocked || !hasNext}
                        className={`${styles.navButton} ${styles.asIconButton}`}
                        aria-label="Next step"
                    >
                        <ChevronRightIcon style={{ width: '16px', height: '16px' }} />
                    </button>
                </div>

                <div className={styles.stepEditorHeaderCluster}>
                    <ButtonComponent
                        ctaText={LABELS.DELETE}
                        variant="outline"
                        size="small"
                        className="red600"
                        startIcon={<TrashIcon className="icon red600" />}
                        onClick={onDelete}
                        disabled={isExecuting}
                        tooltip={LABELS.DELETE}
                    />
                </div>
            </div>
        </div>
    );
}
